import { icons } from "./icons.js";

// Array of current stock chairs
export const currentStock = [
  {
    id: 4,
    image: "./img/stock-00.jpg",
    title: "The Fringe Duchess",
    alt: "a pale green armchair, upholstery ripped and frayed, strands wisping off like a spiders web",
    price: "$404",
    features: [
      { icon: icons.sadFace, label: "Quiet Reflection & Sobbing" },
      { icon: icons.arrowUpLifetime, label: "Comfortable for a Lifetime" },
      { icon: icons.worldGlobe, label: "All Natural Polyester" },
      { icon: icons.weightScale, label: "Weighs 41lbs/18.5kg" },
    ],
  },
  {
    id: 5,
    image: "./img/stock-01.jpg",
    title: "The Elephant Squatter",
    alt: "a wide grey armchair of velvety texture torn only on the arm rests, sat beside a bus",
    price: "$355",
    features: [
      { icon: icons.mobilePhone, label: "Breakfast & Doom Scrolling" },
      { icon: icons.comfortableForDays, label: "Comfortable for 6 Months" },
      { icon: icons.stackedMats, label: "Reassembled Macrofibers" },
      { icon: icons.alertShield, label: "Heft Level Extreme" },
    ],
  },
  {
    id: 6,
    image: "./img/stock-02.jpg",
    title: "The Baby Trainer",
    alt: "a small wood back chair frame with no cushion or arms",
    price: "$99",
    features: [
      { icon: icons.oneHeart, label: "Milk and iPad" },
      { icon: icons.exclamationTriangle, label: "Comfortable for 5 Minutes" },
      { icon: icons.crossedTools, label: "Nailed Together Wood" },
      { icon: icons.weighsNothing, label: "Weighs Almost Nothing" },
    ],
  },
  {
    id: 7,
    image: "./img/stock-03.jpg",
    title: "The Road King",
    alt: "a red patterned armchair stained and burnt in places with a thick piece of foam for a seat featuring graffiti paint",
    price: "$219",
    features: [
      { icon: icons.threeStars, label: "Tattoos & Hair Perms" },
      {
        icon: icons.comfortableForDays,
        label: "Comfortable for Multiple Days",
      },
      { icon: icons.priceTag, label: "100% Egyptian Cotton" },
      { icon: icons.weightScale, label: "Approx 0.0249 Tonnage" },
    ],
  },
  {
    id: 8,
    image: "./img/stock-04.jpg",
    title: "The Secret Gardener",
    alt: "a pattern-backed chair with wooden armrests and filthy seat strewn with debris sat under a bush",
    price: "$179",
    features: [
      { icon: icons.openBook, label: "Journaling & Corn Chips" },
      { icon: icons.timerClock, label: "Comfortable for 3 Hours" },
      { icon: icons.cloudStuffing, label: "Premium Goose Down Stuffing" },
      { icon: icons.unlockedLock, label: "Heft Level Easy" },
    ],
  },
  {
    id: 9,
    image: "./img/stock-05.jpg",
    title: "The Crooked Banker",
    alt: "an aluminum framed chair, broken and laid on its side in the grass",
    price: "$19",
    features: [
      { icon: icons.computerMonitor, label: "Computer & Office Work" },
      { icon: icons.timerClock, label: "Comfortable for 20 Minutes" },
      { icon: icons.openBook, label: "Wet Notebooks & Metal Bars" },
      { icon: icons.weighsNothing, label: "Weighs Almost Nothing" },
    ],
  },
  {
    id: 10,
    image: "./img/stock-06.jpg",
    title: "The Dank Depresser",
    alt: "a short and wide angular grey armchair, made of cardboard but lined with heavily stained and ripped fabric",
    price: "$110",
    features: [
      { icon: icons.tvScreen, label: "Vomiting & Game Shows" },
      { icon: icons.timerClock, label: "Comfortable for 30 Minutes" },
      { icon: icons.stackedBoards, label: "Quad-Slat Premium Cardboard" },
      { icon: icons.weighsOz, label: "Weighs 320 oz." },
    ],
  },
  {
    id: 11,
    image: "./img/stock-07.jpg",
    title: "The Postman's Folly",
    alt: "an upholstered armchair of patterned texture and blue color, missing its cushion, ripped and torn bottom",
    price: "$449",
    features: [
      { icon: icons.puzzlePiece, label: "Luncheon & Jigsaws" },
      { icon: icons.comfortableForDays, label: "Comfortable for 1 Day" },
      { icon: icons.singleStar, label: "Quilted Italian Cambric" },
      { icon: icons.weightScale, label: "Weighs 60lbs/27.2kg" },
    ],
  },
  {
    id: 12,
    image: "./img/stock-08.jpg",
    title: "The Chicken Grinder",
    alt: "a large chair made of wood boards and planks",
    price: "$380",
    features: [
      { icon: icons.ringBuoy, label: "Lifesaving & Sunbathing" },
      { icon: icons.sun, label: "Comfortable for Hot Days" },
      { icon: icons.crossedTools, label: "Nailed Together Wood" },
      { icon: icons.alertShield, label: "Heft Level Extreme" },
    ],
  },
  {
    id: 13,
    image: "./img/stock-09.jpg",
    title: "The Bread Winner",
    alt: "a green wooden chair with destroyed wicker seat",
    price: "$39",
    features: [
      { icon: icons.officeBldg, label: "Working Hard & Eating Bread" },
      { icon: icons.timerClock, label: "Comfortable for 8 Hours" },
      { icon: icons.oneHeart, label: "Poorly Woven Wicker" },
      { icon: icons.weighsNothing, label: "Weighs Almost Nothing" },
    ],
  },
  {
    id: 14,
    image: "./img/stock-10.jpg",
    title: "The Shock Rider",
    alt: "a torn up bicycle seat with spring shocks and rusted metal",
    price: "$45",
    features: [
      { icon: icons.paperAirplane, label: "Limited Edition Bike Seat" },
      { icon: icons.thumbsUp, label: "Comfortable for All Bikes" },
      { icon: icons.magnifyingGlass, label: "Pristine Marred Texture" },
      { icon: icons.weightScale, label: "Weighs 5lbs/2.2kg" },
    ],
  },
  {
    id: 15,
    image: "./img/stock-11.jpg",
    title: "The Vertigo Cure",
    alt: "a dining chair laying on the ground sideways, missing one leg",
    price: "$99",
    features: [
      { icon: icons.openBook, label: "Reading & Writing" },
      { icon: icons.arrowUpLifetime, label: "Comfortable for a Lifetime" },
      { icon: icons.happyFace, label: "Easy-Off Legs" },
      { icon: icons.weighsOz, label: "Weighs 272 oz." },
    ],
  },
  {
    id: 16,
    image: "./img/stock-12.jpg",
    title: "The Slanted Trotter",
    alt: "a padded chair with bent metal frame",
    price: "$150",
    features: [
      { icon: icons.phone, label: "Phone Calls & People Watching" },
      { icon: icons.timerClock, label: "Comfortable for 2-3 Hours" },
      { icon: icons.checkMark, label: "Hollow Steel Pipe Frame" },
      { icon: icons.unlockedLock, label: "Heft Level Easy" },
    ],
  },
  {
    id: 17,
    image: "./img/stock-13.jpg",
    title: "The Big Cheese",
    alt: "a torn armchair with exposed foam padding",
    price: "$500",
    features: [
      { icon: icons.sun, label: "Melancholia & Sunbathing" },
      { icon: icons.comfortableForDays, label: "Comfortable for 6 Months" },
      { icon: icons.foldedMap, label: "Delicate Shalloon Covering" },
      { icon: icons.weightScale, label: "Approx 0.0275 Tonnage" },
    ],
  },
  {
    id: 18,
    image: "./img/stock-14.jpg",
    title: "Chillcore Charley",
    alt: "a green armchair covered in frost with rips and tears",
    price: "$280",
    features: [
      { icon: icons.happyFace, label: "Seated Exercise" },
      { icon: icons.timerClock, label: "20 Minutes" },
      { icon: icons.thumbsUp, label: "Built-In Air Conditioning" },
      { icon: icons.weightScale, label: "Weighs 50lbs/22.6kg" },
    ],
  },
];
